import React from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import moment from "moment";
import "./CalendarToolbar.css";
import { Grid3x3Gap, LayoutThreeColumns } from "react-bootstrap-icons";

const CalendarToolbar = ({ date, view, onNavigate, onView }) => {
  const goToBack = () => {
    onNavigate("PREV");
  };

  const goToNext = () => {
    onNavigate("NEXT");
  };

  const goToToday = () => {
    onNavigate("TODAY");
  };

  const label = () => {
    const currentDate = moment(date);
    if (view === "month") {
      return currentDate.format("MMMM YYYY");
    } else if (view === "week") {
      const start = currentDate.clone().startOf("week");
      const end = currentDate.clone().endOf("week");
      return `${start.format("MMM D")} - ${end.format("MMM D, YYYY")}`;
    } else if (view === "day") {
      return currentDate.format("dddd, MMMM D, YYYY");
    }
    return currentDate.format("MMMM YYYY");
  };

  return (
    <div className="calendar-toolbar">
      <div className="toolbar-left">
        <span className="toolbar-label">{label()}</span>
      </div>
      
      <div className="toolbar-center">
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={goToBack}
          className="nav-btn"
        >
          ‹
        </Button>
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={goToNext}
          className="nav-btn"
        >
          ›
        </Button>
        <Button
          variant="outline-primary"
          size="sm"
          onClick={goToToday}
          className="today-btn"
        >
          Today
        </Button>
      </div>

      <div className="toolbar-right">
        <ButtonGroup className="toolbar-views">
          <Button
            variant={view === "month" ? "primary" : "outline-primary"}
            size="sm"
            onClick={() => onView("month")}
          >
            <Grid3x3Gap className="me-1" />
            Month
          </Button>
          <Button
            variant={view === "week" ? "primary" : "outline-primary"}
            size="sm"
            onClick={() => onView("week")}
          >
            <LayoutThreeColumns className="me-1" />
            Week
          </Button>
        </ButtonGroup>
      </div>
    </div>
  );
};

export default CalendarToolbar;